
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { connect } from "react-redux";
import { UIMixin } from "../../../mixins/uiMixin";
import PropTypes from "prop-types";

class Live extends Component {
    constructor (props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick () {
        return () => {
            this.props.uiClose("settingSportsbook")();
            this.props.uiClose("betslip")();
        };
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

const mapStateToProps = state => {
    return {
        isAsian: state.terminal.isAsian
    };
};

Live.propTypes = {
    uiClose: PropTypes.func
};

export default connect(mapStateToProps)(UIMixin({Component: Live}));